// When the app is embedded in the VSGA website inside an iframe on a HubSpot page, tell that page how
// tall the app is so the iframe can grow and shrink with it, and ask it to scroll to the top when
// the user moves to another step. The page's listener lives in the HubSpot "VIP Card" template.
const inIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

export function startEmbedResize() {
  if (!inIframe) return;
  const root = document.getElementById("root");
  if (!root) return;
  // Keep the first/last child's margins inside #root so they're included in its measured height.
  root.style.display = "flow-root";

  let lastHeight = 0;
  const sendHeight = () => {
    const height = Math.ceil(root.getBoundingClientRect().height);
    if (height === lastHeight) return;
    lastHeight = height;
    window.parent.postMessage({ type: "vsga-vip:height", height }, "*");
  };

  new ResizeObserver(sendHeight).observe(root);
  window.addEventListener("load", sendHeight);
  sendHeight();
}

export function notifyEmbedNavigation() {
  if (inIframe) window.parent.postMessage({ type: "vsga-vip:navigate" }, "*");
  // Mounted straight into the VSGA website page (no iframe): bring the new step into view.
  else if (document.getElementById("vsga-vip-app")) window.scrollTo({ top: 0, behavior: "smooth" });
}
